import { render, staticRenderFns } from "./ImportIndex.vue?vue&type=template&id=1d1c82b2"
import script from "./ImportIndex.vue?vue&type=script&lang=js"
export * from "./ImportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports